(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.frame = 0;
    this.resizeObserver = new ResizeObserver(() => this.schedule());
    this.resizeObserver.observe(this);
    this.update = () => {
      this.frame = 0;
      this.header.style.setProperty('--kg-header-height', this.offsetHeight + 'px');
      this.style.top = Math.max(0, this.header.getBoundingClientRect().top) + 'px';
      const footer = document.querySelector('.kg-footer-promo') || document.getElementById('shopify-section-footer');
      const hidden = Boolean(footer && footer.getBoundingClientRect().top <= window.innerHeight);
      this.header.classList.toggle('kg-footer-reached', hidden);
      this.header.inert = hidden;
    };
    this.schedule = () => {
      if (!this.frame) this.frame = requestAnimationFrame(this.update);
    };
    window.addEventListener('scroll', this.schedule, { passive: true });
    window.addEventListener('resize', this.schedule);
    this.update();
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this.schedule);
    window.removeEventListener('resize', this.schedule);
    cancelAnimationFrame(this.frame);
    this.resizeObserver.disconnect();
    this.header.inert = false;
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
